<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Company Statutory Payments</h1>
    <p>When employees receive statutory payments — such as Statutory Sick Pay (SSP), Statutory Maternity Pay (SMP), Paternity Pay, or Adoption Pay — employers can choose whether or not to top up these payments to match the employee’s usual salary</p>
    <p>Does your company process top-up payments for statutory payments?</p>
    </div>
    <div class="cell small=8">

      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" :value=true v-model="formData.topupPayments">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" :value=false v-model="formData.topupPayments">No<span class="radiomark"></span></label>
      </form>

    </div>


</template>



<script setup>

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';
const error = ref([]);
const route = useRoute();
const taskId = route.params.taskId;

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];

  if (props.formData.topupPayments === undefined || props.formData.topupPayments === null) {
    error.value.push(' Please indicate whether your company processes top-up payments for statutory payments. ');
    return false;
  }

  return true;
}



import { putDataCollectionTask } from '@/services/implementationmanagement.api';
const executeStep = async () => {

    var payload = {
    version: 1,
    dataJson: JSON.stringify(props.formData),
    schemaName: "PayrollConfiguration",
    taskId: taskId,
    taskStatus: "SuccessfullyCompleted"
  }

  var response = await putDataCollectionTask(taskId, payload);

  if (response.status !== 200) {
    error.value = 'Error saving data. Please contact your Qtac account manager.';
    return false;
  }

  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>